import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import ComposerHtmlNotes from './ComposerHtmlNotes';
import { SectionProps } from '@osmosis/shared/types/notes';
import dynamic from 'next/dynamic';

type Props = {
  sections: SectionProps[];
  disableViewerActions?: boolean;
  disableImageViewers?: boolean;
  theme: string;
  themeText: string;
};

const ImageViewer = dynamic(() => import('../../image-viewer/ImageViewer'), {
  ssr: false,
});

/**
 * Notes compooser block sections.
 */
const NotesComposerSections = ({
  sections,
  disableViewerActions,
  disableImageViewers = false,
  theme,
  themeText,
}: Props) => {
  return (
    <>
      {sections.map(
        ({ heading, subheading, text, image, imageAltText, caption }, idx) => (
          <Box
            className="mb-8 flex-col gap-8"
            key={idx}
            data-testid={`notes-composer-section-${idx}-container`}
          >
            {heading && (
              <Box
                className={`text-lg ${
                  themeText || 'text-black'
                } font-tannerscript`}
                data-testid={`notes-composer-section-${idx}-heading`}
              >
                {heading.toUpperCase()}
              </Box>
            )}

            {subheading && (
              <Box>
                <H3
                  data-testid={`notes-composer-section-${idx}-subheading`}
                  className={themeText}
                >
                  {subheading}
                </H3>
              </Box>
            )}

            {text && (
              <ComposerHtmlNotes
                data-testid={`notes-composer-section-${idx}-html-notes-table`}
                html={text}
                theme={theme}
              />
            )}

            {image && (
              <Box>
                <ImageViewer
                  src={image}
                  altText={imageAltText}
                  disableActions={disableViewerActions}
                  disableViewer={disableImageViewers}
                  data-testid={`notes-composer-section-${idx}-image-viewer`}
                />

                {caption && (
                  <Box
                    data-testid={`notes-composer-section-${idx}-image-caption`}
                    dangerouslySetInnerHTML={{
                      __html: caption,
                    }}
                  />
                )}
              </Box>
            )}
          </Box>
        ),
      )}
    </>
  );
};

export default NotesComposerSections;
